import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { HttpService } from './http.service';
import { config } from '../../../providers/config';
import { Observable } from 'rxjs';
import { UtilService } from './util.service';
import { environment } from '../../../environments/environment';
import { LoaderService } from './loader.service';

@Injectable()
export class HotelManagementService {
  selectedBrand:any;
  constructor(
    private http: HttpService, 
    private utilService: UtilService,
    private loaderService: LoaderService
  ) { }


  getHotelInfo(id) {
    return this.http.get(`/hotel/getHotelDetailsById/${id}`)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  addHotelForBrand(formData, isNew): any {
    this.loaderService.show();
    let url = isNew ? `hotel/addHotel` : `hotel/modifyHotel`;
    let  myToken  =  localStorage.getItem('loggedInUser')  ?  JSON.parse(localStorage.getItem('loggedInUser')).token  :  null;
    return Observable.create((observer) => {
      let xhr: XMLHttpRequest = new XMLHttpRequest();
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            observer.next(JSON.parse(xhr.response));
            observer.complete();
            this.loaderService.hide();
          } else {
            observer.error(JSON.parse(xhr.response));
            this.loaderService.hide();
          }
        }
        return () => {
          this.loaderService.hide();
          xhr.abort();
        };
      }
      xhr.open("POST", `${environment.BASE_API}${environment.ROLE}/${url}`, true)
      xhr.setRequestHeader('X-Auth-Token', myToken);
      xhr.send(formData)
    });
  }
  activateOrDeactivateHotel(hotelId, status) {
    return this.http.get(`/hotel/activateOrDeactivateHotel/` + hotelId + `/` + status)
      .map(res => res.json())
      .catch(this.utilService.handleError);
  }

  setSelectedBrand(brand) {
    this.selectedBrand = brand;
  }

  getSelectedBrand() {
    return this.selectedBrand;
  }

  clearSelectedBrand() {
    this.selectedBrand = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/_services/hotel-management.service.ts